import { render } from "./BaseCheckbox.vue?vue&type=template&id=06741cde"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/idse-console/webapps/idse-console/releases/1793606021595/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__